export default __webpack_public_path__ + "static/media/screenshot2_sm.4f1524a9.jpg";